import React from 'react'

import CallbackHandler from 'components/Auth/Callback'

const CallbackPage: React.FC = () => {
  return <CallbackHandler />
}

export default CallbackPage
